import React from 'react'
import { HStack, VStack, Box, Image, Text, Button } from '@chakra-ui/react';
import b1 from '../img/book4/4-1.jpg';
import b2 from '../img/book4/4-2.jpg';
import b3 from '../img/book4/4-3.jpg';
import b4 from '../img/book4/4-4.jpg';
import b5 from '../img/book4/4-5.jpg';
import b6 from '../img/book4/4-6.jpg';
import b7 from '../img/book4/4-7.jpg';
import b8 from '../img/book4/4-8.jpg';
import b9 from '../img/book4/4-9.jpg';
import b10 from '../img/book4/4-10.jpg';
import b11 from '../img/book4/4-11.jpg';
import b12 from '../img/book4/4-12.jpg';
const Books4 = () => {
  return (
    <>
    <VStack spacing={4} align="stretch" alignItems={'center'} mt={4}>
      {/* ---------------------book1--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            borderColor="lightgray"
            bg={'#fff'}
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b1} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    ماذا لو وجدت تنينة غاضبة في بيتك؟
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    الإنجليزية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    علوية الحسان
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    أمل ناصر
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    حكاية قمر
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: N14 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b2} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    اسأل فيلسوفًا
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    مها الفالح
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    إيان اولاسوف
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    تشكيل
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E26 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            bg={'#fff'}
            borderRadius="10px"
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b3} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الانغماس من خلال التصميم
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    سيمون عباس و مأمون تركي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    دوغلاس فيشر - نانسي فراي - راسل جيه كواجليا - دومنيك سميث - ليزا إل لاند
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الكتاب التربوي
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book2--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b4} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    التعلّم عن طريق العمل
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    فوزي الجمال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                        
                    مايك ماتوس - ريتشارد روفر - ربيكا دوفور - روبرت إيكر -توماس و.ماني
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار: &nbsp;
                    <span>
                        دار الكتاب التربوي 
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b5} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان: &nbsp;
                    <span>  
                    الجديد في فن وعلم تعليم الرياضيات
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    فوزي الجمال
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    ناثان دي لانغ - روبورت جاي مارزانو
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الكتاب التربوي
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b6} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    الرعاية من أجل تحقيق تغيير جوهري ومستدام في غرفة الصف
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    فوزي الجمال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    توم روي
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الكتاب التربوي
                        
                    </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book3--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b7} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    تدريس القراءة والكتابة للصفين الثاني والثالث في مجتمع تعلم مهني فعال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    فوزي الجمال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    سارة غورد - كاثرين إي شريدان
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الكتاب التربوي
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b8} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    تدريس القراءة والكتابة من ماقبل الروضة الى الصف الأول في مجتمع تعلم مهني فعال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    فوزي الجمال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    إريكا مارتن - ليزا ماي
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    دار الكتاب التربوي
                        </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b9} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    حركات التفكير
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                        الإنجليزية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                        العربية
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    عبير عماد
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    روجر سوتكليف - توم بيجليستون - جايسن بكلي
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    بصيرة
                    </span>
                  </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
      {/* ---------------------book4--------------------- */}
      <Box>
        <HStack spacing="24px">
          {/* ********* 1 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b10} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span>
                    دليل وضوح المعلم
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span>
                    فوزي الجمال
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    دوغلاس فيشر - نانسي فراي - اوليفيا امادور - جوزيف اسوف
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الكتاب التربوي
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 2 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b11} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    رأسي يتصدع
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    د.نهى عبدالله العويضي
                          </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span>
                    جيمس دانكريت - جون د.إيستوود
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span> 
                    تشكيل
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: E26 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
          {/* ********* 3 ********* */}
          <Box
            maxW="sm"
            borderWidth="1px"
            borderRadius="10px"
            bg={'#fff'}
            borderColor="lightgray"
            overflow="hidden"
                    height={["85vh","95vh"]} w={'25vw'}
          >
            <Image src={b12} alt={'books'} w={'100%'} h={'400px'} />

            <Box p="6">
              <VStack spacing={4} align="stretch">
                <Box>
                  <Text as="b"  >
                    العنوان:&nbsp;
                    <span> 
                    كيف نطوّر عقليات النّماء في غرفة الصف
                        </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة الاصلية:&nbsp;
                    <span>
                    الإنجليزية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اللغة المترجم اليها:&nbsp;
                    <span>
                    العربية
                    </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المترجم:&nbsp;
                    <span> 
                    فوزي الجمال
                      </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    اسم المؤلف:&nbsp;
                    <span> 
                    مايك جيرشون
                         </span>
                  </Text>
                </Box>
                <Box>
                  <Text as="b"  >
                    الدار:&nbsp;
                    <span>
                    دار الكتاب التربوي
                         </span>
                  </Text>
                  <Text  color={'red'}> رقم الجناح: Q8 </Text>
                </Box>
              </VStack>

              <Box display="flex" alignItems="baseline"></Box>
            </Box>
          </Box>
        </HStack>
      </Box>
    </VStack>
  </>
  )
}

export default Books4